import { DateTime } from 'luxon';
import { Box } from 'theme-ui';

export default function TimeRangeDisplay({ start, end, format = DateTime.TIME_SIMPLE, ...props }) {
  // Replace regular space with non-breaking space between time and AM/PM
  const formatTime = (time: DateTime) => {
    return time.toLocaleString(format).replace(/\s(?=AM|PM)/g, '\u00A0');
  };

  return (
    <Box
      as="span"
      {...props}
    >
      {formatTime(start)} - {formatTime(end)}
    </Box>
  );
}
